module.exports = __webpack_public_path__ + "img/RadectPinpointLogo.2b9b2e9c.png";